import { render, staticRenderFns } from "./reasonDialog.vue?vue&type=template&id=d27be80a&scoped=true"
import script from "./reasonDialog.vue?vue&type=script&lang=js"
export * from "./reasonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27be80a",
  null
  
)

export default component.exports